module.exports = __webpack_public_path__ + "static/addproject-f4cc7e914bd75ce9ef392bbfde06a4c7.png";